import { sectionedPanelStyle } from '../CampaignStyles';

export const billingSummaryPanelStyle = {
    ...sectionedPanelStyle
};

export const addInvoicePanelStyle = {
    ...sectionedPanelStyle,
    height: 485
};

export const airtimeReservationTextStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const reservedTextStyle = (textColor) => {
    return {
        color: textColor,
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 500
    };
};

export const panelTitleStyle = {
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500
};

export const campaignBreakdownTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const invoicingBreakdownTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const breakdownMainCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 29,
        border: '1px solid #D7D7D7',
        backgroundColor: i % 2 === 0 ? '#FFFFFF' : '#F7F7F7',
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 15,
        fontWeight: 'bold',
        paddingRight: 27
    };
};

export const invoicingBreakdownValueCellStyle = (valid) => {
    return {
        boxSizing: 'border-box',
        height: 30,
        border: valid ? '1px solid #45AE06' : '1px solid #C40606',
        backgroundColor: valid ? '#F5FFE2' : '#FFF3F3',
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 15,
        fontWeight: 'bold',
        paddingRight: 30
    };
};

export const invoicingListTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const invoicingManagerTableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    layout: 'fixed'
};

export const invoicingListMainCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 29,
        border: '1px solid #D7D7D7',
        backgroundColor: i % 2 === 0 ? '#FFFFFF' : '#F7F7F7',
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 14,
        fontWeight: 500
    };
};

export const invoicingManagerHeadCellStyle = {
    boxSizing: 'border-box',
    height: 90,
    border: '1px solid #E3E3E3',
    backgroundColor: '#FFFFFF',
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    position: 'sticky',
    top: 0,
    textAlign: 'left',
    paddingBottom: 10
};

export const invoicingManagerMainCellStyle = (i) => {
    return {
        boxSizing: 'border-box',
        height: 40,
        border: '1px solid #D7D7D7',
        backgroundColor: i % 2 === 0 ? '#F7F7F7' : '#FFFFFF',
        color: '#414141',
        fontFamily: 'Roboto',
        fontSize: 14,
        paddingLeft: 12,
        paddingRight: 11,
        fontWeight: 500
    };
};

export const invoicingManagerSummaryCellStyle = {
    boxSizing: 'border-box',
    height: 41,
    border: '1px solid #D7D7D7',
    backgroundColor: '#E9E9E9',
    color: '#414141',
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    paddingLeft: 5
};

export const labelStyle = {
    display: 'block',
    textAlign: 'left',
    fontSize: 12,
    color: '#414141',
    marginBottom: 5
};

export const inputStyle = {
    boxSizing: 'border-box',
    width: '100%',
    height: 40,
    outline: 'none',
    autoComplete: 'off',
    padding: '0 12px',
    fontSize: 15,
    letterSpacing: -0.3,
    fontWeight: 600
};

export const scrollbarStyle = {
    position: 'absolute',
    boxSizing: 'border-box',
    height: 281,
    width: 18,
    border: '1px solid #D7D7D7',
    backgroundColor: '#FFFFFF',
    marginLeft: -23,
    marginTop: 47
};

export const datePickerInputStyle = {
    boxSizing: 'border-box',
    height: 40.1,
    outline: 'none',
    padding: '0 2px 0 8px',
    fontSize: 15,
    fontWeight: 600,
    backgroundColor: '#FFFDF4',
    color: '#414141',
    borderRadius: '5px 0 0 5px',
    width: 135
};
export const datePickerButtonStyle = {
    height: 40,
    width: 40,
    marginRight: 20
};
